import PropTypes from 'prop-types';
import './SigIconButton.scss';
import Tooltip from '@mui/material/Tooltip';
import {IconButton} from '@mui/material';

const SigIconButton = (
    {
        buttonProps,
        className,
        icon,
        title,
        tooltipProps,
    }
) => (
    <Tooltip data-testid="SigIconButton"
             title={title}
             arrow
             {...tooltipProps}
    >
    <span className={className}>
      <IconButton {...buttonProps} size="small">
        {icon}
      </IconButton>
    </span>
    </Tooltip>
);

SigIconButton.propTypes = {
    buttonProps: PropTypes.object,
    className: PropTypes.string,
    icon: PropTypes.element.isRequired,
    title: PropTypes.string.isRequired,
    tooltipProps: PropTypes.object,
};

SigIconButton.defaultProps = {};

export default SigIconButton;
